export default values => {
  if (!(values instanceof Array)) throw "Provided values must be an array"

  return val => values.includes(val)
}
